import Big from "big.js";
import _ from "lodash";
import { parseNumber, removeComasStringAmount } from "utils";

export const getObjectValues = (data) => {
  let formValues = {};
  for (const [k, formValue] of Object.entries(data)) {
    formValues[k] = formValue.parseNumber ? parseNumber(formValue.value) : formValue.value;
  }
  return formValues;
};

export const getObjectDifference = (a, b) =>
  Object.fromEntries(
    Object.entries(b).filter(([key, val]) =>
      _.isArray(val)
        ? key in a &&
          !_.isEqual(
            typeof a[key] === "object" ? JSON.stringify(a[key]) : a[key],
            typeof val === "object" ? JSON.stringify(val) : val,
          )
        : typeof val === "object"
          ? JSON.stringify(a[key]) !== JSON.stringify(val)
          : key in a && a[key] !== val,
    ),
  );

export const validateTotalizers = (pumpTotalizers) => {
  return pumpTotalizers.every((item) => {
    const productNames = new Set();

    Object.keys(item).forEach((key) => {
      if (key.startsWith("startTotalizer") && !key.toLowerCase().includes("old")) {
        productNames.add(key.replace("startTotalizer", ""));
      }
    });

    return Array.from(productNames).every((productName) => {
      const startKey = `startTotalizer${productName}`;
      const endKey = `endTotalizer${productName}`;

      if (item[endKey] === "" || item[startKey] === "") {
        return false;
      }

      const startValue = removeComasStringAmount(item[startKey] ?? 0);
      const endValue = removeComasStringAmount(item[endKey] ?? 0);

      return startValue >= 0 && endValue >= 0 && Big(endValue).gte(startValue);
    });
  });
};
